import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import { PRODUCTS } from '../../../data/Products'
import { ORDERS } from '../../../data/Orders'

export default function MyOrders(){

    return(
        <>
            <div className="pb-4">
                <h2 className="text-base font-semibold leading-7 text-gray-900">Mes commandes</h2>
                <p className="text-sm leading-6 text-gray-600">Commandes passées</p>
            </div>
            <div className="space-y-2">
                <Disclosure>
                {({ open }) => (
                    <>
                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-gray-100 px-4 py-2 text-left text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500/75">
                        <span>Commande 1</span>
                        <ChevronUpIcon
                        className={`${
                            open ? 'rotate-180 transform' : ''
                        } h-5 w-5 text-gray-900`}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel className="px-4 pb-2 text-sm text-gray-500">
                        <ul className="divide-y divide-gray-10">
                            {PRODUCTS.map(( item, index ) => index < 3 && (
                                <li key={item.id} className="flex justify-between gap-x-2 py-2">
                                <div className="flex min-w-0 gap-x-4">
                                    <img className="h-12 w-12 flex-none rounded bg-gray-50" src={item.image} alt="" />
                                    <div className="min-w-0 flex-auto">
                                    <p className="text-sm font-semibold leading-6 text-gray-900">{item.name}</p>
                                    {/* <p className="mt-1 truncate text-xs leading-5 text-gray-500 max-w-xs">{item.description}</p> */}
                                    </div>
                                </div>
                                <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p className="text-sm leading-6 text-gray-900">Prix</p>
                                    <p className="text-sm leading-6 text-gray-900">{item.price}$</p>
                                </div>
                                </li>
                            ))}
                            </ul>
                        <div className="flex justify-between items-center py-2">
                            <p className="text-sm text-gray-900">Statut : </p>
                            <p className="text-sm text-gray-900">Prix total : <span className="font-medium">500$</span></p>
                        </div>
                    </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div>
        </>
    )
}